//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const rowSelectSlice = createSlice({
    name: 'rowSelectSlc',
    initialState: {value: { productId: null, laborGroup: null, guild: null,
            contractId: null, contractSectionId: null, csfId: null, cdpId: null, cdpvId: null, cdpvfId: null,
            cdpList: null, status: null
        }},
    reducers:
        // {
        //     changeRowSelect: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeRowSelect: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeRowSelect } = rowSelectSlice.actions;

export default  rowSelectSlice.reducer ;
